import React from "react";
import logo from "../../assets/img/logo1.png";

const navLinks = ["Home", "Our Story", "Founders", "Pricing", "Contact"];

export default function Footer({ setActive }) {
  const handleClick = (l) => {
    if (l === "Home") setActive("home");
    else if (l === "Pricing") setActive("pricing");
    else setActive(l);
  };

  return (
    <footer style={s.footer}>
      <style>{`
        .ft-inner {
          max-width:1200px; margin:0 auto; padding:32px 48px;
          display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:20px;
        }
        .ft-links { display:flex; gap:28px; flex-wrap:wrap; }
        .ft-copy  { max-width:1200px; margin:0 auto; padding:0 48px 24px; font-size:13px; color:#818A9D; }

        @media(max-width:640px){
          .ft-inner { flex-direction:column; align-items:center; padding:32px 24px 20px; gap:24px; }
          .ft-links { justify-content:center; gap:12px 20px; }
          .ft-copy  { padding:0 24px 24px; text-align:center; }
        }
      `}</style>

      <div className="ft-inner">
        <img src={logo} alt="Verisaya" style={s.logo} />
        <div className="ft-links">
          {navLinks.map((l) => (
            <button key={l} onClick={() => handleClick(l)} style={s.link}>{l}</button>
          ))}
        </div>
      </div>
      <div className="ft-copy">© 2026 Verisaya · Verified presence, every time</div>
    </footer>
  );
}

const s = {
  footer: { background: "#080d20", borderTop: "1px solid #1e2e45", fontFamily: "'Segoe UI', sans-serif" },
  logo:   { height: 36, objectFit: "contain" },
  link:   { background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#818A9D", fontFamily: "'Segoe UI', sans-serif" },
};
